"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_apexcharts_1 = __importDefault(require("react-apexcharts"));
const PlateChart_1 = require("../components/PlateChart");
const api_1 = require("@app/api");
const chartsCommon_1 = require("@app/routes/Dashboard/chartsCommon");
const locale_1 = __importDefault(require("../locale"));
const dateUtils_1 = require("@app/utils/dateUtils");
const useChartsDateFilterContext_1 = require("@app/routes/Dashboard/hooks/useChartsDateFilterContext");
const MinutesColumns = () => {
    const [timeData, setTimeData] = (0, react_1.useState)([]);
    const { filterState } = (0, useChartsDateFilterContext_1.useChartsDateFilterContext)();
    (0, react_1.useEffect)(() => {
        // @ts-ignore
        api_1.ApiService.apiChartsCountTimeList(filterState.toDate, filterState.fromDate, undefined, undefined, userId)
            .then(response => setTimeData(response));
    }, [filterState.fromDate, filterState.toDate]);
    const columnsToDisplayCount = 8;
    // @ts-ignore
    const itemsLength = timeData === null || timeData === void 0 ? void 0 : timeData.length;
    const startIndex = itemsLength ? itemsLength - columnsToDisplayCount : 0;
    // @ts-ignore
    const visibleData = timeData; //?.slice(startIndex, itemsLength);
    const timeDataState = {
        series: [{
                // @ts-ignore
                data: visibleData === null || visibleData === void 0 ? void 0 : visibleData.map(e => e.time_user),
                name: locale_1.default.durationOfExercising
            }],
        options: {
            title: {
                text: locale_1.default.durationOfExercising,
                style: chartsCommon_1.titleStyle,
                offsetY: 10
            },
            chart: {
                toolbar: {
                    show: false
                }
            },
            responsive: [
                {
                    breakpoint: 779,
                    options: {
                        chart: {
                            width: 760
                        }
                    }
                },
                {
                    breakpoint: 400,
                    options: {
                        chart: {
                            width: 350
                        }
                    }
                }
            ],
            colors: ['#008CDB'],
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '45%',
                    endingShape: 'rounded',
                    borderRadius: 2
                },
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                show: true,
                width: 5,
                colors: ['transparent']
            },
            xaxis: {
                // @ts-ignore
                categories: visibleData === null || visibleData === void 0 ? void 0 : visibleData.map(e => (0, dateUtils_1.toDayMonth)(e === null || e === void 0 ? void 0 : e.date_t)),
                labels: {
                    style: {
                        fontSize: '8px'
                    }
                }
            },
            yaxis: {
                title: {
                    text: ''
                },
                stepSize: 10,
                min: 0,
                max: 50,
                labels: {
                    formatter: function (val) {
                        return val + ` ${locale_1.default.min}`;
                    }
                }
            },
            fill: {
                opacity: 1
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return val + ` ${locale_1.default.min}`;
                    }
                }
            }
        }
    };
    return (react_1.default.createElement(PlateChart_1.PlateChart, { w: "38%", h: "220px" }, timeData && react_1.default.createElement(react_apexcharts_1.default, { options: timeDataState.options, series: timeDataState.series, type: "bar", width: '300px' })));
};
exports.default = MinutesColumns;
